import { Injectable } from "@angular/core";
import { ResultListVO } from "@app/shared/vo/resultList.vo";
import { CreaFascicoloRequestDTO } from "../dto/crea-fascicolo-requestDTO";
import { CreaFascicoloVO } from "../vo/crea-fascicoloVO";
import { MapperInterface } from "./mapper-inteface";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperPaginazione } from "./mapper-paginazione";
import { FascicoloDTO } from "../dto/fascicoloDTO";
import { FascicoloVO } from "../vo/fascicoloVO";
import { MapperFascicolo } from "./mapper-fascicolo";
import { UnitaDocumentariaDTO } from "../dto/unita-documentariaDTO";
import { UnitaDocumentariaVO } from "../vo/unita-documentariaVO";
import { MapperUnitaDocumentaria } from "./mapper-unita-documentaria";



@Injectable({
    providedIn: 'root'
})
export class MapperResultListUd implements MapperInterface<ResultListDTO<UnitaDocumentariaDTO>, ResultListVO<UnitaDocumentariaVO>> {

    constructor(
        private mapperUd: MapperUnitaDocumentaria,
        private paginazioneMapper: MapperPaginazione) {
    }

    convertVoToDto(vo: ResultListVO<UnitaDocumentariaVO>): ResultListDTO<UnitaDocumentariaDTO> {
        const dto = new ResultListDTO<UnitaDocumentariaDTO>();
        if (vo != null) {
            dto.descrizione = vo.descrizione;
            dto.paginazione = this.paginazioneMapper.convertVoToDto(vo.paginazione);
            dto.stato = vo.stato;
            dto.resultList = this.mapperUd.convertListVoToDto(vo.resultList);
        }
        return dto;
    }

    convertDtoToVo(dto: ResultListDTO<UnitaDocumentariaDTO>): ResultListVO<UnitaDocumentariaVO> {
        const vo = new ResultListVO<UnitaDocumentariaVO>();
        if (dto != null) {
            vo.descrizione = dto.descrizione;
            vo.paginazione = this.paginazioneMapper.convertDtoToVo(dto.paginazione);
            vo.stato = dto.stato;
            vo.resultList = this.mapperUd.convertListDtoToVo(dto.resultList);
        }
        return vo;
    }

    convertListVoToDto(voList: ResultListVO<UnitaDocumentariaVO>[]): ResultListDTO<UnitaDocumentariaDTO>[] {
        return voList.map(vo => this.convertVoToDto(vo));
    }

    convertListDtoToVo(dtoList: ResultListDTO<UnitaDocumentariaDTO>[]): ResultListVO<UnitaDocumentariaVO>[] {
        return dtoList.map(dto => this.convertDtoToVo(dto));
    }
}
